"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _phaser = _interopRequireDefault(require("phaser"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var Boot =
/*#__PURE__*/
function (_Phaser$State) {
  _inherits(Boot, _Phaser$State);

  function Boot() {
    _classCallCheck(this, Boot);

    return _possibleConstructorReturn(this, _getPrototypeOf(Boot).apply(this, arguments));
  }

  _createClass(Boot, [{
    key: "init",
    value: function init() {
      this.game.stage.backgroundColor = '#19233E';
    }
  }, {
    key: "preload",
    value: function preload() {
      this.game.load.path = './';
      this.game.load.spritesheet('action-zone', 'images/game/action-zone.png', 1402, 239);
      this.game.load.image('sidebar', 'images/game/sidebar.png');
      this.game.load.image('exit', 'images/game/exit.png');
      this.game.load.image('header', 'images/game/header.png');
      this.game.load.spritesheet('methylate', 'images/methylate.png', 206, 65);
      this.game.load.spritesheet('demethylate', 'images/demethylate.png', 206, 65);
      this.game.load.spritesheet('play_again', 'images/play_again.png', 206, 56);
      this.game.load.spritesheet('dna-a-t', 'images/game/dna_a_t.png', 586, 54);
      this.game.load.spritesheet('dna-c-g-none', 'images/game/dna_c_g_none.png', 586, 54);
      this.game.load.spritesheet('dna-c-g-left', 'images/game/dna_c_g_left.png', 586, 54);
      this.game.load.spritesheet('dna-c-g-right', 'images/game/dna_c_g_right.png', 586, 54);
      this.game.load.spritesheet('dna-c-g-both', 'images/game/dna_c_g_both.png', 586, 54);
      this.game.load.audio('score_up', 'audio/right_01.mp3');
      this.game.load.audio('score_down', 'audio/wrong_01.mp3');
    }
  }, {
    key: "create",
    value: function create() {
      this.game.physics.startSystem(_phaser.default.Physics.P2JS);
      this.game.physics.p2.setImpactEvents(true);
    }
  }]);

  return Boot;
}(_phaser.default.State);

exports.default = Boot;